import type { ComponentProps } from 'react';

import { useFieldWiring } from '../hooks/use-field-wiring';
import { cn } from '../lib/utils';
import { Field, FieldLabel, type FieldOverrides, FieldSlot } from './field';
import { Textarea } from './textarea';

type Props = ComponentProps<typeof Textarea> & {
    label: string;
    description?: string;
    error?: boolean | string;
    fieldProps?: FieldOverrides;
    fieldClassName?: string;
};

function TextareaField({
    label,
    description,
    error,
    id,
    fieldProps,
    fieldClassName,
    ...textareaProps
}: Props) {
    const wiring = useFieldWiring({ id, description, error });
    const { className: fieldPropsClassName, ...restFieldProps } = fieldProps ?? {};

    return (
        <Field
            data-disabled={textareaProps.disabled}
            data-invalid={wiring.dataInvalid}
            className={cn(fieldPropsClassName, fieldClassName)}
            {...restFieldProps}
        >
            <FieldLabel htmlFor={wiring.controlId}>{label}</FieldLabel>
            <Textarea {...textareaProps} {...wiring.controlProps} />
            <FieldSlot
                description={description}
                descriptionId={wiring.descriptionId}
                errorMessage={wiring.errorMessage}
                errorId={wiring.errorId}
            />
        </Field>
    );
}

export { TextareaField };
